import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useRef } from 'react';
const UniqueIdContext = createContext({});
export const UniqueIdProvider = ({ children, }) => {
    const countIndexRef = useRef({});
    return (_jsx(UniqueIdContext.Provider, Object.assign({ value: countIndexRef.current }, { children: children })));
};
export const useUniqueId = (prefix) => {
    const countIndex = useContext(UniqueIdContext);
    return useMemo(() => {
        var _a;
        const idForPrefix = ((_a = countIndex[prefix]) === null || _a === void 0 ? void 0 : _a.count) || 1;
        if (!countIndex[prefix]) {
            countIndex[prefix] = {
                count: 2,
            };
        }
        else {
            countIndex[prefix].count += 1;
        }
        return `${prefix}-${idForPrefix}`;
    }, []);
};
